var MEMBERSHIPTYPE = {
  PERSONMEMBER: 1,
  AGENCYMEMBER: 2,
  NONMEMBER: 3
};

module.exports = MEMBERSHIPTYPE;
